import type { TFunction } from 'i18next';
import { capitalize } from 'lodash';
import moment from 'moment-timezone';

import type { Goal } from '@feathr/blackbox';
import { goalTypeLabels } from '@feathr/extender/components/Goal/Goal.predicates';
import { TimeFormat } from '@feathr/hooks';

import { formatGoalValue } from '../ReportsConversionsGoalManagerPage.utils';

/**
 * Builds the subtitle string displayed beneath the goal name on the detail page.
 *
 * @param goal - The goal model instance.
 * @param t - The i18next translation function.
 * @returns The formatted subtitle string.
 */
export function formatGoalSubtitle(goal: Goal, t: TFunction): string {
  const convType = goal.get('conv_type');
  const rawLabel = goalTypeLabels[convType] ?? convType ?? '';
  const typeLabel = capitalize(rawLabel);
  const valueLabel = formatGoalValue(goal, t);
  const dateLastModified = goal.get('date_last_modified');
  const editedDate = dateLastModified
    ? moment.utc(dateLastModified).format(TimeFormat.longDate)
    : '—';

  return [typeLabel, `${t('Value')}: ${valueLabel}`, `${t('Edited')} ${editedDate}`].join(' · ');
}
